import { ApiAddress } from "@/services/apis"
import request from "@/services/request"
import { Equipment } from "./equipment.model"
import { SimiulatorEquipment } from "@/types/equipment"


export async function getProjectEquipments(): Promise<Equipment.Base[]> {
  return await request.get(ApiAddress.EQUIPMENTS)
}

export async function getEquipment(id: number): Promise<Equipment.Info> {
  return await request.get(ApiAddress.EQUIPMENT, {params: {id}})
}

export async function createProjectEquipments(body: Omit<Equipment.Base, 'id'>): Promise<Equipment.Base> {
  return await request.post(ApiAddress.EQUIPMENTS, body)
}

export function updateEquipment(id: number, body: any) {
  return request.put(ApiAddress.EQUIPMENT, body, {params: {id}})
}

export async function deleteEquipment(id: number): Promise<Equipment.Base> {
  return await request.delete(ApiAddress.EQUIPMENT, {params: {id}})
}

export function getEquipmentById(id: number): Promise<SimiulatorEquipment> {
  return request.get(ApiAddress.EQUIPMENT, {params: {id}})
}

export function addNozzleToEquipment(equipmentId: number, nozzle: Omit<Equipment.Nozzle, 'id'>) {
  return request.post(ApiAddress.EQUIPMENT_NOZZLES, nozzle, {params: {equipmentId}})
}

export function deleteNozzleFromEquipment(equipmentId: number, id: number) {
  return request.delete(ApiAddress.EQUIPMENT_NOZZLE, {params: {equipmentId, id}})
}

export function updateEquipmentNozzle(body, params: {id: number, equipmentId: number}) {
  return request.put(ApiAddress.EQUIPMENT_NOZZLE, body, {params})
}

export const OrganizationEquipmentService = {
  getEquipments: (orgId: number): Promise<Equipment.Base[]> => {
    return request.get(ApiAddress.ORGANIZATION_EQUIPMENTS, { params: { orgId } })
  },
  getEquipment: (id: number): Promise<SimiulatorEquipment> => {
    return request.get(ApiAddress.EQUIPMENT, { params: { id } })
  },
  createEquipment: (orgId: number, body: Omit<Equipment.Base, 'id'>): Promise<Equipment.Base> => {
    return request.post(ApiAddress.ORGANIZATION_EQUIPMENTS, body, { params: { orgId } })
  },
  updateEquipment: (id: number, body: any) => {
    return request.put(ApiAddress.EQUIPMENT, body, { params: { id } })
  },
  deleteEquipment: (id: number): Promise<Equipment.Base> => {
    return request.delete(ApiAddress.EQUIPMENT, { params: { id } })
  },
  // Reusing standard endpoints for nozzles as they are dependent on equipment ID
  // If backend requires orgId in path for nozzles, we'd need new endpoints.
  // Assuming standard endpoints work if user has access to equipment.
  addNozzleToEquipment: (orgId: number, equipmentId: number, nozzle: Omit<Equipment.Nozzle, 'id'>) => {
     // Pass orgId in params just in case backend uses it from query
    return request.post(ApiAddress.EQUIPMENT_NOZZLES, nozzle, {params: {equipmentId, orgId}})
  },
  deleteNozzleFromEquipment: (orgId: number, equipmentId: number, id: number) => {
    return request.delete(ApiAddress.EQUIPMENT_NOZZLE, {params: {equipmentId, id, orgId}})
  },
  updateEquipmentNozzle: (orgId: number, body, params: {id: number, equipmentId: number}) => {
    return request.put(ApiAddress.EQUIPMENT_NOZZLE, body, {params: {...params, orgId}})
  }
}
